// @flow

const liquidMessageEditorStyles = {
  inputCtr: (theme) => ({
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  }),

  EditZone: (theme) => ({
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  }),

  textAreaCtr: (theme) => ({
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  }),

  simpleBorder: (theme) => ({
    boxShadow: 'none',
    border: `1px solid ${theme.palette.border.color}`
  }),

  toolbarCtr: (theme) => ({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    borderBottom: `1px solid ${theme.palette.border.color}`,
    padding: `${theme.spacing(0.5)} ${theme.spacing(1)}`,
    '& button': {
      textTransform: 'capitalize'
    }
  }),

  grow: (theme) => ({
    flexGrow: 1
  }),

  squareTheme: (theme) => ({
    borderRadius: 0
  }),

  menuList: (theme) => ({
    zIndex: 9999
  }),

  menuTitle: (theme) => ({
    color: 'hsl(0,0%,70%)',
    fontWeight: 600,
    fontSize: '0.9rem',
    textTransform: 'uppercase',
    '&:hover': {
      backgroundColor: 'transparent'
    }
  }),

  toolbarMenuBtn: (theme) => ({
    width: 'fit-content',
    height: '2rem',
    borderRadius: 0,
    textTransform: 'capitalize',
    border: '1px solid #5c6bc0',
    borderRadius: 6,
    fontWeight: 600,
    padding: `${theme.spacing(0.4)} ${theme.spacing(1)}`
  }),

  error: (theme) => ({
    color: theme.palette.status.error.main,
    '& *': {
      color: theme.palette.status.error.main
    }
  }),

  previewZone: (theme) => ({
    whiteSpace: 'pre-wrap',
    width: '100%',
    height: 225,
    padding: `${theme.spacing(2.7)} ${theme.spacing(2.6)}`,
    fontSize: '1rem',
    color: theme.palette.custom.disabledText,
    border: `1px solid ${theme.palette.border.color}`,
    overflow: 'scroll',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      padding: `${theme.spacing(2)} ${theme.spacing(1.5)}`
    }
  }),

  largeTextField: (theme) => ({
    width: '100%',
    height: 225,
    '& *': {
      borderRadius: 0
    },
    '& label': {
      transform: 'translate(20px, 24px) scale(1)'
    },
    '& .MuiOutlinedInput-notchedOutline': {
      top: 0
    },
    '& .MuiOutlinedInput-notchedOutline legend': {
      display: 'none'
    },
    '& textarea': {
      padding: theme.spacing(1)
    },
    '& label.MuiInputLabel-shrink': {
      display: 'none',
      transform: 'translate(12px, -6px) scale(0.75)',
      fontSize: '1rem'
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      '& textarea': {
        padding: theme.spacing(0.5)
      }
    }
  }),

  secondInput: (theme) => ({
    '& *': {
      zIndex: 1
    }
  }),

  toggleNavButtons: (theme) => ({
    '& button': {
      borderRadius: 0,
      padding: `${theme.spacing(1)} ${theme.spacing(3)}`
    },
    '& button:not(:last-child)': {
      borderLeft: '1px solid rgba(0,0,0,0.12) !important'
    }
  }),

  navBtnDeselected: (theme) => ({
    color: 'rgba(0, 0, 0, 0.38)',
    backgroundColor: 'transparent',
    fontWeight: 600,
    padding: '0px 24px',
    borderTop: '1px solid rgba(0,0,0,0.12) !important',
    borderRight: '1px solid rgba(0,0,0,0.12) !important',
    borderLeft: 0,
    borderBottom: 0
  }),

  navBtnSelected: (theme) => ({
    '& span': {
      color: theme.palette.custom.neoViolet.main
    },
    backgroundColor: `${theme.palette.custom.neoYellow.main} !important`,
    fontWeight: 600,
    padding: '0px 24px',
    borderBottom: 0,
    borderTop: '1px solid rgba(0,0,0,0.12) !important',
    borderRight: '1px solid rgba(0,0,0,0.12) !important',
    borderLeft: '1px solid rgba(0,0,0,0.12) !important'
  }),

  characterCounterCtr: (theme) => ({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
    marginTop: theme.spacing(0.5),
    width: '100%'
  }),

  characterCounter: (theme) => ({
    textAlign: 'right',
    color: theme.palette.primary.light,
    fontSize: '0.8rem'
  }),

  warningText: (theme) => ({
    color: theme.palette.error.main,
    fontSize: '0.9rem'
  })
};

export default liquidMessageEditorStyles;
